module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('Modal', {
    attrs: {
      "title": "作品评分"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [_c('Form', {
    ref: "userVideoForm",
    staticClass: "form",
    attrs: {
      "model": _vm.userVideoParams,
      "rules": _vm.userVideoRules,
      "label-width": 80
    }
  }, [_c('Row', [_c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', [_vm._v("\n          学生：" + _vm._s(_vm.userVideoParams.userId) + "-" + _vm._s(_vm.userVideoParams.userName) + "\n        ")])], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', [_vm._v("\n          作品名称：" + _vm._s(_vm.userVideoParams.title) + "\n        ")])], 1)], 1), _vm._v(" "), _c('Col', {
    attrs: {
      "span": 22
    }
  }, [_c('Form-item', {
    attrs: {
      "label": "评分",
      "prop": "score"
    }
  }, [_c('Input', {
    model: {
      value: (_vm.userVideoParams.score),
      callback: function($$v) {
        _vm.$set(_vm.userVideoParams, "score", $$v)
      },
      expression: "userVideoParams.score"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('Button', {
    attrs: {
      "type": "text",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.visible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('Button', {
    attrs: {
      "type": "primary",
      "size": "large",
      "loading": _vm.loadingEditModal
    },
    on: {
      "click": _vm.editUserVideo
    }
  }, [_vm._v("提交")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1e3f1337","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/safenessVote/modal/EditUserVideoModal.vue
// module id = 1688
// module chunks = 8